module.exports = __webpack_public_path__ + "static/media/24UHCHR22.51fcf035.jpg";